module.exports = __webpack_public_path__ + "static/media/kn.170a2ee4.svg";